/* eslint-disable @typescript-eslint/naming-convention */
import type { Dispatch, SetStateAction } from "react";

import type { ISite } from "@similarweb/ui-components";

import type { ICompetitors } from "app/pages/activation/components/Settings/Competitors/types";

import type { GaMappingSettings } from "../../components/Settings/TabsContent/GeneralTab/GaSection/types";

export enum SettingsTabs {
    General = "general",
    Subscriptions = "subscriptions",
    NewsSettings = "newsSettings",
}

export type SettingsConfigEntity = Record<SettingsTabs, { id: SettingsTabs; title: string }>;

export enum CompetitorActions {
    add = "add",
    set = "set",
    remove = "remove",
    removeAll = "removeAll",
}

export enum AssetKey {
    competitors = "competitors",
    mainCompetitors = "mainCompetitors",
}

export type CompetitorsPayload = {
    assetKey: AssetKey;
    selectedItem?: ISite;
    isMainCompetitorsActive?: boolean;
    asset?: ISite[];
};

export type DataToSaveSchema = {
    selectedCountry: number;
    selectedWebsite: ISite;
    competitors: ICompetitors;
    gaMapping: GaMappingSettings;
    isGeneralSettingsChanged: boolean;
    trafficSource: string;
    activationSetName: string;
    nameError: { isError: boolean; errorMessage: string };
    onSubscribe: () => void;
    onSaveNewsSettings: () => Promise<void>;
};

export type SetDataToSave = Dispatch<SetStateAction<DataToSaveSchema>>;
